import * as React from "react"

// close on esc key
export const useKeyHandler = (keyCode: number, handler: () => void): void => {
	const closeOnEscKeyRef = React.useRef(
		(e: KeyboardEvent) => e.keyCode === keyCode && handler(),
	)

	React.useEffect(() => {
		const closeOnEscKey = closeOnEscKeyRef.current
		closeOnEscKey && document.addEventListener("keydown", closeOnEscKey)

		return () => {
			closeOnEscKey && document.removeEventListener("keydown", closeOnEscKey)
		}
	}, [closeOnEscKeyRef])
}
